const BASE = "https://clavex.objetivabroker.es/api";

// ── Token en memoria (nunca localStorage) ──────────────────
let _token = null;
export const setToken   = (t) => { _token = t; };
export const clearToken = ()  => { _token = null; };
export const getToken   = ()  => _token;

async function request(method, path, body, retry = true) {
  const headers = { "Content-Type": "application/json" };
  if (_token) headers["Authorization"] = `Bearer ${_token}`;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401 && retry) {
    const refreshed = await tryRefresh();
    if (refreshed) return request(method, path, body, false);
    clearToken();
    window.location.reload();
    return;
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const d = err.detail;
    const msg = typeof d === "string" ? d : (d && d.message) || "Error de red";
    const e = new Error(msg);
    e.status = res.status;
    e.detail = d;
    throw e;
  }
  return res.json();
}

async function tryRefresh() {
  try {
    const res = await fetch(`${BASE}/auth/refresh`, {
      method: "POST",
      credentials: "include",
    });
    if (!res.ok) return false;
    const data = await res.json();
    setToken(data.access_token);
    return true;
  } catch {
    return false;
  }
}

export const api = {
  login: async (email, password) => {
    const data = await request("POST", "/auth/login", { email, password });
    if (data.access_token) setToken(data.access_token);
    return data;
  },
  logout: async () => {
    await fetch(`${BASE}/auth/logout`, { method: "POST", credentials: "include" });
    clearToken();
  },
  me:             () => request("GET",    "/auth/me"),
  getAudit:       () => request("GET",    "/vault/audit"),
  getShared:      () => request("GET",    "/vault/shared"),
  addShared:      (cred, force = false) => request("POST",   `/vault/shared${force ? "?force=true" : ""}`, cred),
  updateShared:   (id, data) => request("PUT", `/vault/shared/${id}`, data),
  deleteShared:   (id)   => request("DELETE", `/vault/shared/${id}`),
  getPersonal:    () => request("GET",    "/vault/personal"),
  addPersonal:    (cred, force = false) => request("POST",   `/vault/personal${force ? "?force=true" : ""}`, cred),
  updatePersonal: (id, data) => request("PUT", `/vault/personal/${id}`, data),
  deletePersonal: (id)   => request("DELETE", `/vault/personal/${id}`),
};
